module.exports = __webpack_public_path__ + "static/wenda-logo-cade27739b9dbdbfeeb20fc85657fa1f.svg";